import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalController, NavController, IonContent } from '@ionic/angular/standalone';

@Component({
  selector: 'modal-booking-blocked',
  templateUrl: 'modal-booking-blocked.component.html',
  styleUrls: ['modal-booking-blocked.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'legacy-styles' },
  imports: [IonContent],
})
export class ModalBookingBlockedComponent {
  private modalController = inject(ModalController);
  private navController = inject(NavController);

  async dismiss() {
    await this.modalController.dismiss();
  }

  async goToDocuments() {
    await this.dismiss();
    this.navController.navigateForward('/documents');
  }

  async goToCode() {
    await this.dismiss();
    this.navController.navigateForward('/code');
  }
}
